import '../Scss/style.scss';

import {defineAsyncComponent, createApp} from 'vue';
import {Component} from '@vue/runtime-core';

import { Vue3Odometer } from 'vue3-odometer';

import store from "./Store";

// Main Components
const MainComponent = defineAsyncComponent(() => import('./Components/MainComponent.vue'));
const FormComponent = defineAsyncComponent(() => import('./Components/FormComponent.vue'));

// Elements
const RadioComponent = defineAsyncComponent(() => import('./Components/Form/RadioComponent.vue'));
const ModalComponent = defineAsyncComponent(() => import('./Components/Form/ModalComponent.vue'));
const SelectComponent = defineAsyncComponent(() => import('./Components/Form/SelectComponent.vue'));
const DateComponent = defineAsyncComponent(() => import('./Components/Form/DateComponent.vue'));
const InputComponent = defineAsyncComponent(() => import('./Components/Form/InputComponent.vue'));
const HsnTsnWarningComponent = defineAsyncComponent(() => import('./Components/Form/HsnTsnWarningComponent.vue'));

// Partials
const MotorcycleComponent = defineAsyncComponent(() => import('./Components/Partials/MotorcycleComponent.vue'));
const CarComponent = defineAsyncComponent(() => import('./Components/Partials/CarComponent.vue'));
const ResultComponent = defineAsyncComponent(() => import('./Components/Partials/ResultComponent.vue'));

// Icons
const CalendarIcon = defineAsyncComponent(() => import('./Components/Icons/Calendar.vue'));
const InfoIcon = defineAsyncComponent(() => import('./Components/Icons/Info.vue'));
const WarningTriangleIcon = defineAsyncComponent(() => import('./Components/Icons/WarningTriangle.vue'));

const projectRootComponent: Component = {
    components: {
        MainComponent,
        FormComponent,
        RadioComponent,
        ModalComponent,
        SelectComponent,
        DateComponent,
        InputComponent,
        HsnTsnWarningComponent,
        MotorcycleComponent,
        CarComponent,
        ResultComponent,
        CalendarIcon,
        InfoIcon,
        WarningTriangleIcon
    },
};

// @ts-ignore
const app = createApp(projectRootComponent);

// Use Vuex store
app.use(store);

app.config.globalProperties.window = window

app.mount('#shortEvalApp');